import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared-module/shared.module';
import { AnalyticsDetailsComponent } from './analytics-details/analytics-details.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxChartsModule } from '@swimlane/ngx-charts';

export const COMPONENTS = [AnalyticsDetailsComponent];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FlexLayoutModule,
    SharedModule,
    TranslateModule,
    NgxChartsModule,
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
  providers: [],
})
export class ComponentsModule {}
